import {Component, ComponentFactoryResolver, ComponentRef, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent implements OnInit {

  @Input() modalTitle: string;
  @Output() itemSaved: Subject<boolean>;
  objId: number;
  objMessage: string;
  component: any;
  @ViewChild('container', { read: ViewContainerRef, static: true }) viewContainerRef: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.itemSaved = new Subject();
    this.addEditor();
  }
  addEditor() {
    const comp: any = this.component;
    const factory = this.componentFactoryResolver.resolveComponentFactory(this.component);
    const ref = this.viewContainerRef.createComponent(factory);
    /*const ref2: ComponentRef<GenericModalComponent> = this.viewContainerRef.createComponent(factory);
    ref.instance.objId = this.objId;
    ref2.instance.objId = this.objId;
    ref.instance.objMessage = this.objMessage;*/

    ref.changeDetectorRef.detectChanges();
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

}
